<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='角色信息管理' label2="修改角色信息" url="/system/role/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <el-row>
          <el-col :span="12">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色级别：</label>
              <div class="col-lg-8">
                <el-form-item prop="rolelevel" :rules="{required: true, message: '角色级别不能为空', trigger: 'blur'}">
                  <el-select v-model="form.rolelevel" style="width: 100%;">
                    <el-option v-for="item in this.$utils.RoleLevel" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色名称：</label>
              <div class="col-lg-8">
                <el-form-item prop="rolename" :rules="{required: true, message: '角色名称不能为空', trigger: 'blur'}">
                  <el-input v-model="form.rolename"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色描述：</label>
              <div class="col-lg-8">
                <el-input v-model="form.roledesc"></el-input>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">单位范围：</label>
              <div class="col-lg-8">
                <FormHospitalMultipleSelect :multiple="multiple" v-model="form.hosrange"></FormHospitalMultipleSelect>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">人员类型范围：</label>
              <div class="col-lg-8">
                <FormDictItemMultipleSelect :multiple="multiple" :dictid="this.$utils.DictEnum.usertype" v-model="form.usertyperange"></FormDictItemMultipleSelect>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">权限范围：</label>
              <div class="col-lg-8">
                <el-tree :data="tableData" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current
                  :props="defaultProps" @check-change="getCheckedItems"></el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="m-form__actions m-form__actions--solid">
          <div class="row">
            <div class="col-lg-12" style="text-align: center;">
              <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RoleEdit',
    data() {
      return {
        form: {
          id: '',
          rolename: '',
          roletype: 2,
          rolelevel: 0,
          roledesc: '',
          hosrange: [],
          usertyperange: [],
          token: '',
          rolepower: ''
        },
        tableData: [{}],
        multiple: true,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        fullscreenLoading: false
      }
    },
    methods: {
      getCheckedItems: function() {
        this.form.rolepower = this.$refs.tree.getCheckedKeys()
      },
      Save: function() {
        this.fullscreenLoading = true
        this.form.rolepower = this.$refs.tree.getCheckedKeys()
        this.$http.post(this.$utils.Url.system + '/systemapi/role/update', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              console.log('保存成功')
              this.$router.push('/main/system/role/list')
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '保存失败',
              type: 'error'
            })
            this.fullscreenLoading = false
          })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      var that = this
      var args = {
        token: this.form.token,
        id: this.form.id
      }
      // 加载角色信息
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/info', args, function(data) {
        that.form.rolename = data.Data.RoleName
        that.form.roletype = data.Data.RoleType
        that.form.rolelevel = data.Data.RoleLevel
        that.form.roledesc = data.Data.RoleDesc

        var i = 0
        if (data.Data.UserTypeRange != null && data.Data.UserTypeRange != '') {
          var usertypes = data.Data.UserTypeRange.split(',')
          for (i = 0; i < usertypes.length; i++) {
            that.form.usertyperange.push(parseInt(usertypes[i]))
          }
        }
        if (data.Data.HosRange != null && data.Data.HosRange != '') {
          var hoss = data.Data.HosRange.split(',')
          for (i = 0; i < hoss.length; i++) {
            that.form.hosrange.push(parseInt(hoss[i]))
          }
        }
      }, null, null)
      // 加载权限树
      var args2 = {
        token: this.form.token
      }
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/powerlist', args2, function(d) {
        that.tableData = d.Data
      }, null, null)
      // 加载角色权限
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/powerlist', args, function(d) {
        that.$refs.tree.setCheckedKeys(d.Data.split(','))
      }, null, null)
    }
  }
</script>

<style>
</style>
